import { IconProps } from "../../utils/global-types/global-types";

const CommunicationsToggleIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M11.667 3.667H6.333A5.34 5.34 0 0 0 1 9a5.34 5.34 0 0 0 5.333 5.333h5.334A5.34 5.34 0 0 0 17 9a5.34 5.34 0 0 0-5.333-5.333m0 9.333c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.795 4-4 4"
      ></path>
    </svg>
  );
};

export default CommunicationsToggleIcon;
